import { render, staticRenderFns } from "./ChatListPage.vue?vue&type=template&id=399363d8&scoped=true"
import script from "./ChatListPage.vue?vue&type=script&lang=js"
export * from "./ChatListPage.vue?vue&type=script&lang=js"
import style0 from "./ChatListPage.vue?vue&type=style&index=0&id=399363d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399363d8",
  null
  
)

export default component.exports